<template>
  <div class="dev">
    <div class="group scripts">
      <div class="menu">
        <sui-button-group size="mini" vertical>
          <sui-button v-for="(scriptURL, scriptName) in scripts" :key="scriptName" @click="addScript(scriptURL)">{{scriptName}}</sui-button>
        </sui-button-group>
      </div>
      <sui-button icon="big download" size="mini" />
    </div>
    <div class="group">
      <div class="menu">
        <sui-button-group size="mini" vertical>
          <sui-button :active="user.email === email" v-for="(password, email) in config.users" :key="email" @click="selectUser(email, password)">{{email}}</sui-button>
        </sui-button-group>
      </div>
      <sui-button icon="big users" size="mini" />
    </div>
    <div class="group">
      <div class="menu">
        <sui-button-group size="mini" vertical>
          <sui-button :active="config.apiAddress.includes(config.domains[0])" v-if="config.domains[0]" @click="selectDomain(config.domains[0])">{{config.domains[0]}}</sui-button>
          <sui-button :active="config.apiAddress.includes(config.domains[1])" v-if="config.domains[1]" @click="selectDomain(config.domains[1])">{{config.domains[1]}}</sui-button>
          <sui-button :active="config.apiAddress.includes(config.domains[2])" v-if="config.domains[2]" @click="selectDomain(config.domains[2])">{{config.domains[2]}}</sui-button>
        </sui-button-group>
      </div>
      <sui-button icon="big code branch" size="mini" />
    </div>
    <div class="group">
      <div class="menu">
        <sui-button-group size="big" vertical>
          <sui-button icon="big power" size="mini" color="red" @click="exit()"></sui-button>
          <sui-button :icon="config.owner ? 'big crown green' : 'big crown'" size="mini" @click="toggleOwner()"></sui-button>
          <sui-button :icon="config.tracking ? 'big eye' : 'big slash eye'" size="mini" style="display: none!important" @click="toggleTracking()"></sui-button>
        </sui-button-group>
      </div>
      <sui-button icon="big user secret" size="mini" />
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import api from '@/api'
  import logger from '@/logger'
  import store from '@/store'
  import router from '@/router'
  import utils from '@/utils'

  export default {
    name: 'Dev',
    data() {
      return {
        scripts: {
          cookie: 'https://unpkg.com/js-cookie',
          async: 'https://unpkg.com/async',
          bluebird: 'https://unpkg.com/bluebird',
          axios: 'https://unpkg.com/axios',
          jquery: 'https://unpkg.com/jquery',
          moment: 'https://unpkg.com/moment',
          lodash: 'https://unpkg.com/lodash',
        },
      }
    },
    computed: {
      ...mapGetters(['config', 'user']),
      usersList() {
        return this.config.users.map()
      },
    },
    methods: {
      exit() {
        store.dispatch('updateConfig', {debug: false})
      },
      toggleTracking() {
        store.dispatch('update', {sessionConfig: {...store.state.sessionConfig, tracking: !this.config.tracking}})
      },
      toggleOwner() {
        store.dispatch('updateConfig', {owner: this.config.owner ? false : true})
      },
      selectDomain(domain) {
        const apiAddress = `https://api.${domain}`
        const wsAddress = `https://ws.${domain}`
        if (apiAddress !== this.config.apiAddress || wsAddress !== this.config.wsAddress) {
          store.dispatch('logout')
          store.dispatch('updateConfig', {domain, apiAddress, wsAddress})
          api.reconnect()
          router.push('/user/login')
        }
      },
      selectUser(email, password) {
        if (email === this.user.email) {
          return
        }
        router.push('/').catch(() => {})
        store.dispatch('logout')
        api.login(email, password).then(data => {
          store.dispatch('login', data.member.token)
          api.reconnect()
        })
      },
      addScript(scriptURL) {
        utils.addScript(scriptURL)
        document.querySelector('.scripts .menu').style.display = 'none'
        setTimeout(() => {
          document.querySelector('.scripts .menu').style.removeProperty('display')
        }, 500)
      },
    },
    created() {
      logger.info('Init debug tools')

      if ('newEntity' in window) {
        return false
      }

      Object.defineProperties(window, {
        entity: {
          get() {
            const $el = document.querySelector('.page')
            const $vm = $el ? $el.__vue__ : null
            return $vm ? $vm.host || $vm.service || $vm.project || $vm.entity : null
          },
        },
        newEntity: {
          get() {
            const $el = document.querySelector('.modals.active')
            const $vm = $el ? $el.__vue__ : null
            return $vm ? $vm.$parent.entity : this.entity
          },
        },
        oldEntity: {
          get() {
            const newEntity = window.newEntity
            return newEntity ? store.getters[`${newEntity.target}s`].find(entity => entity.id === newEntity.id) : null
          },
        },
      })

      for (const getter in store.getters) {
        Object.defineProperty(window, getter, { get() { return store.getters[getter] } })
      }
    },
  }
</script>

<style scoped>
  .dev { position: fixed; right: 1em; bottom: 1em; z-index: 2147483646; display: flex; }
  .group { position: relative; }
  .group:hover .menu { display: flex; }
  .menu { display: none; position: absolute; left: 50%; bottom: 100%; transform: translate(-50%); padding-bottom: .2em; align-items: flex-end; }
  .item { display: flex; }
  .button { display: flex!important; justify-content: center!important; white-space: nowrap; }
  .logo { padding: .1em!important; }
  .image { height: 1.4em; }
</style>
